
<html>
    <body>
        <div class="row" >
            <div class="col-md-5">
                <mat-card>
                    <mat-card-content>
        
                    </mat-card-content>
                </mat-card>
            </div>
            <div class="col-md-5">
                <mat-card>
                    <mat-card-content>
                        
                    </mat-card-content>
                </mat-card>
            </div>
        </div>
    </body>
</html>
